import { render, staticRenderFns } from "./StrategyProjectActive.vue?vue&type=template&id=25d541ba&scoped=true"
import script from "./StrategyProjectActive.vue?vue&type=script&lang=js"
export * from "./StrategyProjectActive.vue?vue&type=script&lang=js"
import style0 from "./StrategyProjectActive.vue?vue&type=style&index=0&id=25d541ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d541ba",
  null
  
)

export default component.exports